import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  // Restaurant ID
  restaurantId?: any;
  isProfile = true;
  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.params.subscribe(params => {
      this.restaurantId = params['id'];
    });
  }

  ngOnInit(): void {
  }

  navigateToSideBar(restaurantId: any) {
    localStorage.setItem('restaurantId', restaurantId)
  }

}
